import ProfileContactsForm from '@/components/Forms/ProfileContactsForm';
import { updateProfileContacts } from '@/store/services/userServices';
import { useGetMe } from '@/hooks/useGetMe';

const ProfilePersonalModal = ({ onClose, preSaved, onOutsideClick }) => {
  const { profile: user, refetchProfile } = useGetMe();

  const onSubmit = values => {
    const payload = {
      address: values.address,
      city: values.city,
      country: values.country,
      country_code: values.country_code,
      postal_code: values.postal_code,
      phone: values.phone,
      citizenship: values.citizenship,
      citizenship_code: values.citizenship_code,
      origin_of_funds: values.origin_of_funds,
      monthly_investment: values.planned_monthly_investment,
    };

    updateProfileContacts(payload).then(res => {
      if (res && res.success) {
        refetchProfile();
        onClose();
      }
    });
  };

  const handleOutsideClick = values => {
    onOutsideClick && onOutsideClick(values);
    onClose();
  };

  return (
    <ProfileContactsForm
      user={user}
      onSubmit={onSubmit}
      onCancel={onClose}
      preSaved={preSaved}
      onOutsideClick={handleOutsideClick}
    />
  );
};

export default ProfilePersonalModal;
